







import { Component, Prop, Vue } from 'vue-property-decorator';
import DownloadWx from './components/common/download-wx.vue';
import OutsidePage from './components/outside-wx/outside-page.vue';
import { url } from '@tencent/wphk-base-utils';
import { isTencentCharity } from '@/business/helper';

@Component({
  components: {
    DownloadWx,
    OutsidePage,
  },
})
export default class CIndex extends Vue {
  beforeCreate() {
    // 需要去掉token登陆参数，以防用户后续用重复token访问页面
    const tokenKey = '_stk';
    const token = url.getUrlParam(tokenKey);
    if (token) {
      location.replace(url.removeUrlParam(location.href, tokenKey)) ;
    }
  }
  get bgColor() {
    let bgColor = url.getUrlParam('bgColor') || '';
    if (!/[0-9a-z]/i.test(bgColor)) {
      bgColor = 'ffb8c0';
      // 8b2792
    }
    // 99公益日专属背景色
    if (isTencentCharity()) {
      bgColor = 'EFECE4';
    }
    return `#${bgColor}`;
  }
}
